/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-lines */


import ks, {
    kTime,
    kObject,
    kObjectArray,
    kBoolean,
} from "../ReUsableTS/kalmstromShared4";
import LNG from "./kLNG";
import { kStyleClass, kStyles } from "./kStyles";
import { kIcon } from "./kFluentIcons";
/** @description For reading and writing html docs
 */
export class kHTMLDoc {
    public Doc: Document | null = null;
    public Body: HTMLBodyElement | null = null;
    public constructor() {
        this.Doc = document.implementation.createHTMLDocument();
        this.Body = this.Doc.getElementsByTagName("body")[0];
    }

    /** @description Loads a html document from string */
    public FromString = (HTML: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const Parser: DOMParser = new DOMParser();
            this.Doc = Parser.parseFromString(HTML, "text/html");
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLDoc.FromString");
        }
    };
    public ToString = (): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            //https://stackoverflow.com/questions/3913355/how-to-format-tidy-beautify-in-javascript#27367462
            const tab = "\t";
            let result = "";
            let indent = "";
            //var Elem: string = "";
            let Elem: any = null;
            if (null !== this.Doc) {
                const Elems: string[] =
                    this.Doc.documentElement.outerHTML.split(/>\s*</);
                for (Elem of Elems) {
                    if (Elem.match(/^\/\w/)) {
                        indent = indent.substring(tab.length);
                    }
                    result += indent + "<" + Elem + ">\r\n";
                    if (
                        Elem.match(/^<?\w[^>]*[^/]$/) &&
                        !Elem.startsWith("input")
                    ) {
                        //https://stackoverflow.com/questions/61324375/startswith-throws-error-while-using-typescript
                        indent += tab;
                    }
                }
            }
            return result.substring(1, result.length - 3);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLDoc.ToString");
            return "";
        }
    };
    public GetTableByID = (TableID?: string): kHTMLTable | null => {
        if (ks.kErrorMode === true) {
            return null;
        }
        try {
            const ResultTable: kHTMLTable = new kHTMLTable();
            if (undefined !== TableID) {
                if (null !== this.Doc) {
                    ResultTable.Table = this.Doc.getElementById(
                        TableID
                    ) as HTMLTableElement;
                }
            } else {
                if (null !== this.Doc) {
                    const Tables: any = this.Doc.getElementsByTagName("table"); //NodeListOf<HTMLTableElement>
                    if (Tables.length > 0) {
                        ResultTable.Table = Tables.item(0) as HTMLTableElement;
                    }
                }
            }
            ResultTable.getTableParts();
            return ResultTable;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.GetTableByID");
            return null;
        }
    };
}
export class kHTMLTable {
    //https://code-boxx.com/editable-html-table/#sec-extra
    //https://codepen.io/alexerlandsson/pen/mPWgpO
    public Borders = false;
    public Table: HTMLTableElement = document.createElement("table");
    public Header: HTMLTableSectionElement | null = null;
    public Footer: HTMLTableSectionElement | null = null;
    public Body: HTMLTableSectionElement | null = null;
    public Rows: kHTMLRow[] = [];
    public Visible = true;
    public constructor(ID?: string) {
        this.Table = document.createElement("table");
        if (ks.kNotNullOrUndefined(ID)) {
            this.Table.id = ks.nz(ID);
        }
        this.StartOver();
    }
    public StartOver = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.Table.innerHTML = "";
            this.Header = document.createElement("thead");
            this.Table.appendChild(this.Header);
            this.Body = document.createElement("tbody");
            this.Table.appendChild(this.Body);
            this.Footer = document.createElement("tfoot");
            this.Table.appendChild(this.Footer);
            this.Rows = [];
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.StartOver");
        }
    };
    public getRows = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let i = 0;
            let CurrRow: HTMLTableRowElement | null = null;
            let RowObj: kHTMLRow | null = null;
            this.Rows = [];
            if (null !== this.Table) {
                if (this.Table.tBodies.length === 1) {
                    this.Body = this.Table.tBodies.item(0);
                    if (null !== this.Body) {
                        const RowElements: HTMLCollectionOf<Element> =
                            this.Body.rows;
                        for (i = 0; i < RowElements.length; i++) {
                            CurrRow = RowElements.item(
                                i
                            ) as HTMLTableRowElement;
                            if (CurrRow.getElementsByTagName("td").length > 0) {
                                RowObj = new kHTMLRow();
                                RowObj.Row = CurrRow;
                                RowObj.GetCells();
                                this.Rows.push(RowObj);
                            }
                        }
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.getRows");
        }
    };
    public AddBorders = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.AddStyles();
            this.Table.classList.add("kBlackTable");
            this.Borders = true;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddBorders");
        }
    };
    public AddRoundedBorders = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Table) {
                this.Table.style.border = "thin solid grey";
                this.Table.style.borderRadius = "5px";
                this.Table.style.margin = "5px";
                this.Table.style.borderCollapse = "AddRoundedBorders";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddBorders");
        }
    };
    public AddRowObject = (
        ExistingRow: HTMLTableRowElement
    ): kHTMLRow | null => {
        if (ks.kErrorMode === true) {
            return null;
        }
        try {
            const NewRow: kHTMLRow = new kHTMLRow();
            NewRow.Row = ExistingRow;
            if (null !== this.Body) {
                this.Body.appendChild(NewRow.Row);
                this.Rows.push(NewRow);
                return NewRow;
            }
            return null;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddRow");
            return null;
        }
    };
    public AddRow = (Content: string): kHTMLRow => {
        if (ks.kErrorMode === true) {
            return new kHTMLRow();
        }
        try {
            const NewRow: kHTMLRow = new kHTMLRow();
            const NewCell: HTMLTableCellElement | null =
                NewRow.AddCell(Content);
            if (null !== NewCell) {
                NewRow.Cells.push(NewCell);
                if (null !== this.Body) {
                    if (null !== NewRow.Row) {
                        this.Body.appendChild(NewRow.Row);
                    }
                    this.Rows.push(NewRow);
                    return NewRow;
                }
            }
            return new kHTMLRow();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddRow");
            return new kHTMLRow();
        }
    };
    public AddHeaders = (
        HeaderTitles: string[],
        MinimumWidths?: number[],
        Alignments?: string[]
    ): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let CurrHeaderCellElement: HTMLTableCellElement | null = null;
            const HeaderRow: HTMLTableRowElement = document.createElement("tr");
            let CurrTitle = "";
            let i = 0;

            for (CurrTitle of HeaderTitles) {
                CurrHeaderCellElement = document.createElement("th");
                CurrHeaderCellElement.textContent = CurrTitle;
                CurrHeaderCellElement.style.textAlign = "left";
                if (undefined !== Alignments) {
                    if (Alignments.length > i) {
                        CurrHeaderCellElement.style.textAlign = ks.nz(
                            Alignments[i]
                        );
                    }
                }
                if (undefined !== MinimumWidths) {
                    if (ks.kNotNullOrUndefined(MinimumWidths[i])) {
                        CurrHeaderCellElement.style.minWidth =
                            MinimumWidths[i].toString() + "px";
                    }
                }
                HeaderRow.appendChild(CurrHeaderCellElement);
                i++;
            }
            if (this.Header !== null) {
                this.Header.appendChild(HeaderRow);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddHeaders");
        }
    };
     public MergeSingleHeader = (Columns:number): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if(this.Table.tHead){
                const HeaderRow:HTMLTableRowElement|null = this.Table.tHead.rows.item(0);
                if(HeaderRow){
                    const HeaderCell:HTMLTableCellElement|null = HeaderRow.childNodes.item(0) as HTMLTableCellElement;
                    if(HeaderCell){
                        HeaderCell.colSpan = Columns;
                        HeaderCell.style.textAlign = "center";
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.MergeSingleHeader");
        }
    };   
    public AddTotalFooter = (
        Caption: string,
        FirstColumnColumns = 0,
        Summary: string
    ): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const FooterRow: HTMLTableRowElement = document.createElement("tr");
            const LabelCellElement: HTMLTableCellElement =
                document.createElement("th");
            LabelCellElement.textContent = Caption;
            LabelCellElement.colSpan = FirstColumnColumns;
            LabelCellElement.style.textAlign = "left";
            FooterRow.appendChild(LabelCellElement);

            const SummaryCellElement: HTMLTableCellElement =
                document.createElement("th");
            SummaryCellElement.style.textAlign = "right";
            SummaryCellElement.textContent = Summary;
            FooterRow.appendChild(SummaryCellElement);
            if (this.Footer !== null) {
                this.Footer.appendChild(FooterRow);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddHeaders");
        }
    };

    public AddEmptyRow = (ID?: string): kHTMLRow => {
        if (ks.kErrorMode === true) {
            return new kHTMLRow();
        }
        try {
            const NewRow: kHTMLRow = new kHTMLRow();
            if (null !== this.Body) {
                if (null !== NewRow.Row) {
                    this.Body.appendChild(NewRow.Row);
                    if (ks.kNotNullOrUndefined(ID)) {
                        NewRow.Row.id = ks.nz(ID);
                    }
                }
            }
            return NewRow;
        } catch (e) {
            //debugger;
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddEmptyRow");
            return new kHTMLRow();
        }
    };

    public AddRowFirstWithElement = (Elem: HTMLElement): kHTMLRow | null => {
        if (ks.kErrorMode === true) {
            return null;
        }
        try {
            const NewRow: kHTMLRow = new kHTMLRow();
            if (this.Body) {
                NewRow.Row = this.Body.insertRow(0);
                NewRow.AddCellWithElement(Elem);
                return NewRow;
            } else {
                return null;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddRowFirstWithElement");
            return null;
        }
    };
    public AddRowWithElement = (Elem: HTMLElement): kHTMLRow => {
        if (ks.kErrorMode === true) {
            return new kHTMLRow();
        }
        try {
            const NewRow: kHTMLRow = new kHTMLRow();
            NewRow.AddCellWithElement(Elem);
            if (null !== this.Body) {
                if (null !== NewRow.Row) {
                    this.Body.appendChild(NewRow.Row);
                }
            }
            return NewRow;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddRowWithElement");
            return new kHTMLRow();
        }
    };
    public getTableParts = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Table) {
                const Headers: any = this.Table.getElementsByTagName("thead");
                if (Headers.length > 0) {
                    this.Header = Headers.item(0) as HTMLTableSectionElement;
                }
                const Bodies: any = this.Table.getElementsByTagName("tbody");
                if (Bodies.length > 0) {
                    this.Body = Bodies.item(0) as HTMLTableSectionElement;
                }
                const Footers: any = this.Table.getElementsByTagName("tfoot");
                if (Footers.length > 0) {
                    this.Footer = Footers.item(0) as HTMLTableSectionElement;
                }
                this.getRows();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.getTableParts");
        }
    };
    public FromString = (HTML: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Table) {
                this.Table.innerHTML = HTML;
                this.getTableParts();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.FromString");
        }
    };
    public Toggle = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.Visible === true) {
                this.Hide();
            } else {
                this.Show();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.Toggle");
        }
    };
    public Show = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Table) {
                this.Table.style.display = "inline";
                this.Visible = true;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.Show");
        }
    };
    public Hide = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Table) {
                this.Table.style.display = "none";
                this.Visible = false;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.Hide");
        }
    };

    private static StylesInjected: boolean = false;

    public AddStyles = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (kHTMLTable.StylesInjected) { return; }
            const Style: HTMLStyleElement = document.createElement("style");
            Style.id = "kHTMLTableStyles";
            Style.innerHTML = kHTMLTable.GetStyle();
            document.head.appendChild(Style);
            kHTMLTable.StylesInjected = true;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddStyles");
            return;
        }
    }
    public static GetStyle = (): string => {
        if (ks.kErrorMode === true) { return ""; }
        try {
            return `

                .kBlackTable{
                    width: 100%;
                    text-align: left;
                    border-collapse: collapse;
                }
                .kBlackTable td, .kBlackTable th {
                    border: 1px solid #000000;
                    padding: 5px 4px;
                }
                .kBlackTable thead:first-child {
                    background:#038387;
                    border-bottom: 3px solid #000000;
                    color: #FFFFFF;
                }
                .kBlackTable thead th {
                    font-weight: bold;
                    color: #FFFFFF;
                    background: #038387;
                    text-align: left;
                }
                .kBlackTable tr:nth-child(even) {
                    background: lightgrey;
                }
                `
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLTable.AddStyles");
            return "";
        }
    }
}
export class kHTMLRow {
    public Row: HTMLTableRowElement;
    public Cells: HTMLTableCellElement[] = [];
    public constructor() {
        this.Row = document.createElement("tr");
        const DefaultRowStyle:kStyleClass = kStyles.AddStyle("kRowDef");
        if(DefaultRowStyle.Saved ===false){
            DefaultRowStyle.Style.verticalAlign = "top";
        }
        DefaultRowStyle.Apply(this.Row);
    }

    public AddCellHTML = (
        Content: string,
        ClassName?: string
    ): HTMLTableCellElement => {
        if (ks.kErrorMode === true) {
            return document.createElement("td");
        }
        try {
            const NewCell: HTMLTableCellElement | null = this.AddCell(
                undefined,
                ClassName
            );
            if (null !== NewCell) {
                NewCell.innerHTML = Content;
                if (null !== this.Row) {
                    this.Row.appendChild(NewCell);
                }
                return NewCell;
            }
            return document.createElement("td");
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.AddCellHTML");
            return document.createElement("td");
        }
    };
    public AddNumberCell = (
        Content?: number,
        ClassName?: string
    ): HTMLTableCellElement => {
        if (ks.kErrorMode === true) {
            return document.createElement("td");
        }
        try {
            if (undefined === Content) {
                Content = 0;
            }
            const NewCell: HTMLTableCellElement | null = this.AddCell(
                Content.toString(),
                ClassName
            );
            if (null !== NewCell) {
                NewCell.style.textAlign = "right";
            }

            return NewCell;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.AddNumberCell");
            return document.createElement("td");
        }
    };
    public AddCell = (
        Content?: string,
        ClassName?: string
    ): HTMLTableCellElement => {
        if (ks.kErrorMode === true) {
            return document.createElement("td");
        }
        try {
            const NewCell: HTMLTableCellElement = this._AddCell();
            if (undefined !== Content) {
                if (null !== NewCell) {
                    NewCell.textContent = Content;
                }
            }
            if (undefined !== ClassName) {
                if (ks.kNotEmptyString(ClassName)) {
                    if (null !== NewCell) {
                        NewCell.className = ClassName;
                    }
                }
            }
            if (null !== this.Row) {
                if (null !== NewCell) {
                    this.Row.appendChild(NewCell);
                }
            }
            return NewCell;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.AddRow");
            return document.createElement("td");
        }
    };
    public AddMergedCell = (Cols: number): HTMLTableCellElement => {
        if (ks.kErrorMode === true) {
            return document.createElement("td");
        }
        try {
            const NewCell: HTMLTableCellElement = document.createElement("td");
            NewCell.colSpan = Cols;
            if (null !== this.Row) {
                this.Row.appendChild(NewCell);
            }
            return NewCell;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.AddMergedCell");
            return document.createElement("td");
        }
    };
    public AddCellFirst = (): HTMLTableCellElement | null => {
        if (ks.kErrorMode === true) {
            return null;
        }
        try {
            const NewCell: HTMLTableCellElement | null = this._AddCell();
            if (this.Row !== null && NewCell !== null) {
                this.Row.insertBefore(NewCell, this.Row.firstChild);
            }
            return NewCell;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.AddCellFirst");
            return null;
        }
    };
    public AddCellWithElement = (Elem: HTMLElement|SVGSVGElement): HTMLTableCellElement => {
        if (ks.kErrorMode === true) {
            return document.createElement("td");
        }
        try {
            if (Elem) {
                const NewCell: HTMLTableCellElement | null = this._AddCell();
                if (null !== NewCell) {
                    NewCell.appendChild(Elem);
                    if (null !== this.Row) {
                        this.Row.appendChild(NewCell);
                    }
                }
                return NewCell;
            } else {
                return document.createElement("td");
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.AddCellWithElement");
            return document.createElement("td");
        }
    };
    public GetCellInnerHTML = (ClassName: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            const Cell: HTMLTableCellElement | null =
                this.GetCellByClassName(ClassName);
            if (null !== Cell) {
                return Cell.innerHTML;
            }
            return "";
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.GetCellInnerHTML");
            return "";
        }
    };
    public GetCellTextValue = (ClassName: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            const Cell: HTMLTableCellElement | null =
                this.GetCellByClassName(ClassName);
            if (null !== Cell) {
                return ks.nz(Cell.textContent).trim();
            } else {
                return "";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.GetCellTextValue");
            return "";
        }
    };

    public GetCells = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.Cells = [];
            //var CellObjs: HTMLCollectionOf<HTMLTableCellElement> = this.Row.getElementsByTagName("td");
            if (null !== this.Row) {
                const CellObjs: any = this.Row.getElementsByTagName("td");
                let Counter = 0;
                for (Counter = 0; Counter < CellObjs.length; Counter++) {
                    const CurrCell: HTMLTableCellElement = CellObjs.item(
                        Counter
                    ) as HTMLTableCellElement;
                    if (CurrCell.parentElement === this.Row) {
                        //Only direct decentants
                        this.Cells.push(CurrCell);
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.GetCells");
        }
    };
    public GetCellByIndex = (Index: number): HTMLTableCellElement | null => {
        if (ks.kErrorMode === true) {
            return null;
        }
        try {
            if (this.Cells.length === 0) {
                this.GetCells();
            }
            if (this.Cells.length >= Index) {
                return this.Cells[Index];
            }
            return null;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.GetCells");
            return null;
        }
    };
    public GetCellNumberValue = (ClassName: string): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            const Cell: HTMLTableCellElement | null =
                this.GetCellByClassName(ClassName);
            if (null !== Cell) {
                return parseInt(ks.nz(Cell.textContent));
            }
            return 0;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.GetCellNumberValue");
            return 0;
        }
    };
    public GetCellByClassName = (
        ClassName: string
    ): HTMLTableCellElement | null => {
        if (ks.kErrorMode === true) {
            return null;
        }
        try {
            let Cell: HTMLTableCellElement | null = null;
            if (null !== this.Row) {
                Cell = this.Row.getElementsByClassName(
                    ClassName
                )[0] as HTMLTableCellElement;
            }
            return Cell;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow.GetCellTextValue");
            return null;
        }
    };
    private _AddCell = (): HTMLTableCellElement => {
        if (ks.kErrorMode === true) {
            return document.createElement("td");
        }
        try {
            const NewCell: HTMLTableCellElement = document.createElement("td");
            NewCell.style.verticalAlign = "top";
            return NewCell;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLRow._AddCell");
            return document.createElement("td");
        }
    };
}
export class kDateInput {
    constructor() {
        this.Input = document.createElement("input");
        this.Input.type = "date";
        this.ChosenDate = new kTime();
        this.Input.value = this.ChosenDate.ToISODate();
        this.Input.style.borderColor = "grey";
        this.Input.style.borderWidth = "thin";
        this.Input.addEventListener("change", this._DateChange);
    }
    public Input: HTMLInputElement = document.createElement("input");
    public ParentID = "";
    public ParentElement: Element | null = null;
    public ID = "";
    public ChosenDate: kTime | null = null;
    public ChangeCB: any | null = null;
    public Create = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.Input) {
                this.Input.id = this.ID;
                if (null !== this.ParentElement) {
                    this.ParentElement.appendChild(this.Input);
                } else {
                    if (ks.kNotEmptyString(this.ParentID)) {
                        this.ParentElement = document.getElementById(
                            this.ParentID
                        );
                        if (null !== this.ParentElement) {
                            this.ParentElement.appendChild(this.Input);
                        }
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kDateInput.Create");
        }
    };
    private _DateChange = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.ChosenDate = new kTime();
            if (null !== this.Input) {
                this.ChosenDate.fromISO(this.Input.value);
            }
            ks.DoCallBack(this.ChangeCB, null, false);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kDateInput._DateChange");
        }
    };
    public SetBykDate = (NewDate: kTime | null|""): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if(NewDate!==""){
                if (null !== this.Input && null !== NewDate) {
                    this.Input.value = NewDate.ToISODate();
                }
                this.ChosenDate = NewDate;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kDateInput.SetBykDate ");
        }
    };
}

export class kDiv {
    public Div: HTMLDivElement = document.createElement("div");
    public constructor(ID?: string) {
        this.Div = document.createElement("div");
        if (ks.kNotNullOrUndefined(ID)) {
            if (null !== this.Div) {
                this.Div.id = ks.nz(ID);
            }
        }
    }
}

export class kProgressTable {
    public Table: kHTMLTable = new kHTMLTable();
    public DonePerc = 0;
    public DoneCell: HTMLTableCellElement = document.createElement("td");
    public ToDoCell: HTMLTableCellElement = document.createElement("td");
    public Parent: HTMLElement | null = null;
    public ChangeCB: any | null = null;
    public Changable = true;
    public Width = 600;
    public CaptionCell: HTMLTableCellElement | null = null;
    public Create = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.Table = new kHTMLTable();
            if (null !== this.Table.Table) {
                this.Table.Table.style.width = this.Width + "px";
                this.Table.Table.style.cursor = "pointer";
                this.Table.Table.style.borderCollapse = "collapse";
                this.Table.AddBorders();
            }

            const ProgressColorRow: kHTMLRow | null = this.Table.AddEmptyRow();
            if (null !== ProgressColorRow) {
                if (null !== ProgressColorRow.Row) {
                    ProgressColorRow.Row.style.padding = "0px";

                    this.DoneCell = ProgressColorRow.AddCell();
                    if (null !== this.DoneCell) {
                        const DoneStyle: CSSStyleDeclaration =
                            this.DoneCell.style;
                        DoneStyle.backgroundColor = "blue";
                        DoneStyle.borderRadius = "5px";
                        DoneStyle.height = "12px";
                        DoneStyle.display = "table-cell";
                        DoneStyle.color = "white";
                        DoneStyle.textAlign = "center";
                        DoneStyle.transitionProperty = "width";
                        DoneStyle.transitionDuration = "1s";
                    }
                    this.ToDoCell = ProgressColorRow.AddCell();
                    if (null !== this.ToDoCell) {
                        this.ToDoCell.style.height = "12px";
                        this.ToDoCell.style.display = "table-cell";
                    }
                    if (this.Changable && this.DoneCell && this.ToDoCell) {
                        this.DoneCell.addEventListener(
                            "click",
                            this._DoneClick
                        );
                        this.ToDoCell.addEventListener(
                            "click",
                            this._TodoClick
                        );
                    }
                }
            }
            // const CaptionRow: kHTMLRow | null = this.Table.AddEmptyRow();
            // if(CaptionRow){
            //     this.CaptionCell = CaptionRow.AddMergedCell(2);
            // }
            this.SetDone(this.DonePerc);
            if (null !== this.Parent) {
                if (null !== this.Table.Table) {
                    this.Parent.appendChild(this.Table.Table);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kProgressTable.Create");
        }
    };
    /** @description Set the progress bar width.
     * @param {NewPerc} Use an integer between 0 and 100
     */
    public SetDone = (NewPerc: number): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.DonePerc = NewPerc;
            NewPerc = Math.floor(NewPerc);
            if (
                this.DoneCell &&
                this.ToDoCell &&
                this.Table &&
                this.Table.Table
            ) {
                //this.DoneCell.textContent = NewPerc.toString() + "%";
                this.DoneCell.style.width = NewPerc + "%";
                if (NewPerc !== 100) {
                    this.ToDoCell.style.width = 100 - NewPerc + "%";
                    this.ToDoCell.style.display = "table-cell";
                } else {
                    this.ToDoCell.style.display = "none";
                }
                this.Table.Table.title = NewPerc.toString() + "%";
                this.DoneCell.textContent = NewPerc.toString() + "%";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kProgressTable.SetDone");
        }
    };
    public SetTooltip = (TooltipText: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.Table.Table.title = TooltipText;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kProgressTable.SetTooltip");
        }
    };
    private _DoneClick = (Event: MouseEvent): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.Table && this.Table.Table && this.DoneCell) {
                const TotalWidth: number = this.Table.Table.clientWidth;
                const ClickLeft = Event.offsetX;
                let NewPerc: number = (ClickLeft / TotalWidth) * 100;
                NewPerc = Math.round(NewPerc / 10) * 10;
                this.SetDone(NewPerc);
                ks.DoCallBack(this.ChangeCB, this.DonePerc, false);
                Event.preventDefault();
                Event.stopPropagation();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kProgressTable._DoneClick");
        }
    };
    private _TodoClick = (Event: MouseEvent): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.Table && this.Table.Table && this.ToDoCell) {
                const RemainingPerc: number = 100 - this.DonePerc;
                let NewPerc: number =
                    this.DonePerc +
                    RemainingPerc * (Event.offsetX / this.ToDoCell.clientWidth);
                NewPerc = Math.round(NewPerc / 10) * 10;
                this.SetDone(NewPerc);
                ks.DoCallBack(this.ChangeCB, this.DonePerc, false);
                Event.preventDefault();
                Event.stopPropagation();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kProgressTable._TodoClick");
        }
    };
}

export class kCheckboxTable {
    public Table: kHTMLTable | null = null;
    public CurrentArray: kObjectArray | null = null;
    public ParentID = "";
    public CheckBoxes: kCheckBoxForUncheck[] = [];
    // eslint-disable-next-line @typescript-eslint/ban-types
    public ArrayChangedCB: Function | null = null;
    public MultiChoice = true;
    public constructor() {
        this.Table = new kHTMLTable();
    }

    public FromArray = (ParentID: string, ArrayToShow: kObjectArray): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.CurrentArray = ArrayToShow;
            this.ParentID = ParentID;
            this.Render();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kCheckboxTable.AddToElement");
        }
    };
    public ItemClicked = (UncheckedObject: kObject): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.CurrentArray) {
                this.CurrentArray.RemoveItemByUniqueID(
                    UncheckedObject.UniqueID
                );
                this.Render();
            }
            ks.DoCallBack(this.ArrayChangedCB, null, false);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kCheckboxTable.ItemClicked");
        }
    };
    public Render = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let CurrObject: kObject | null = null;
            let CurrRow: kHTMLRow | null = null;
            let CurrCheck: kCheckBoxForUncheck | null = null;
            const ParentElement: HTMLElement | null = document.getElementById(this.ParentID);
            if (ParentElement !== null) {
                ParentElement.innerHTML = "";
            }
            this.Table = new kHTMLTable();
            if (this.MultiChoice === false) {
                if (null !== this.CurrentArray) {
                    if (this.CurrentArray.Items.length > 1) {
                        const LatestItem: kObject | undefined =
                            this.CurrentArray.Items.pop();
                        this.CurrentArray.Items = [];
                        if (undefined !== LatestItem) {
                            this.CurrentArray.Items.push(LatestItem);
                        }
                    }
                }
            }
            if (null !== this.CurrentArray) {
                for (CurrObject of this.CurrentArray.Items) {
                    CurrRow = this.Table.AddEmptyRow();
                    CurrCheck = new kCheckBoxForUncheck();
                    CurrCheck.ClickCB = this.ItemClicked;
                    if (null !== CurrRow) {
                        CurrCheck.AddToElement(CurrRow.Row, CurrObject);
                    }
                }
            }
            const ParentEl: HTMLElement | null = document.getElementById(
                this.ParentID
            );
            if (null !== ParentEl) {
                if (null !== this.Table.Table) {
                    ParentEl.appendChild(this.Table.Table);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kCheckboxTable.Render");
        }
    };
}

export class kCheckBoxForUncheck {
    // eslint-disable-next-line @typescript-eslint/ban-types
    public ClickCB: Function | null = null;
    public CheckBox: HTMLInputElement | null = null;
    public ParentElement: Element | null = null;
    public RelatedObject: kObject | null = null;

    public AddToElement = (
        ParentElement: Element | null,
        ObjectToShow: kObject
    ): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const ContainerDiv: HTMLDivElement | null = new kDiv().Div;
            this.ParentElement = ParentElement;
            this.RelatedObject = ObjectToShow;

            this.CheckBox = document.createElement("input");
            this.CheckBox.type = "checkbox";
            this.CheckBox.checked = true;
            this.CheckBox.addEventListener("change", this._CheckboxClick);
            if (null !== ContainerDiv) {
                ContainerDiv.appendChild(this.CheckBox);
                const Link: HTMLAnchorElement | null = ObjectToShow.ToAnchor();
                if (null !== Link) {
                    ContainerDiv.appendChild(Link);
                }
                if (null !== this.ParentElement) {
                    this.ParentElement.appendChild(ContainerDiv);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kCheckBoxForUncheck.AddToElement");
        }
    };
    private _CheckboxClick = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            ks.DoCallBack(this.ClickCB, this.RelatedObject);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kCheckBoxForUncheck._CheckboxClick");
        }
    };
}

export class kHTMLCheckBox {
    public CheckboxValue = false;
    public ClickCB: any | null = null;
    public CheckBox: HTMLInputElement = document.createElement("input");
    public Label:HTMLLabelElement = document.createElement("label");
    public constructor(ID?: string) {
        this.CheckBox = document.createElement("input");
        this.CheckBox.type = "checkbox";
        this.CheckBox.addEventListener("click", this._CheckboxClick);
        if (ks.kNotNullOrUndefined(ID)) {
            this.CheckBox.id = ks.nz(ID);
        }else{
            this.CheckBox.id = "kHTMLCheckBox" +  Math.floor(Math.random() * 1000);
        }
        this.Label.htmlFor = this.CheckBox.id;
        this.Label.style.verticalAlign = "top";
    }
    public FromkBool = (YesNo: kBoolean): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.SetCheckedStatus(YesNo.Value);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kCheckbox.FromkBool");
        }
    };
    // eslint-disable-next-line @typescript-eslint/ban-types



    private _CheckboxClick = (event:MouseEvent): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            event.preventDefault();
            if (this.CheckBox) {
                this.CheckboxValue = this.CheckBox.checked;
            }
            ks.DoCallBack(this.ClickCB, undefined, false);
            ks.AddDelayedAction(
                "Checkbox reset SP fix",
                this._ResetValueInSP,
                "If not the SP built in code will mess with the checkbox",
                100
            );
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLCheckBox._CheckboxClick");
            return;
        }
    };
    private _ResetValueInSP = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.CheckBox) {
                this.CheckBox.checked = this.CheckboxValue;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLCheckBox._ResetValueInSP");
        }
    };
    public check = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.CheckBox.checked = true;
            this.CheckboxValue = true;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLCheckBox.check");
            return;
        }
    };

    public SetCheckedStatus = (NewValue: boolean): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.CheckBox) {
                this.CheckBox.checked = NewValue;
                this.CheckboxValue = NewValue;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kHTMLCheckBox.SetCheckedStatus");
            return;
        }
    };
}
export class kSelect {
    public Select: HTMLSelectElement;
    public ChangeCB: any = null;
    public NewCB: any = null;
    public Editable: boolean = false;
    public DataList: HTMLDataListElement | null = null;
    public Choices: string[] = [];
    public constructor(ID?: string) {
        this.Select = document.createElement("select");
        this.Select.addEventListener("change", this._SelectChange);
        this.Select.style.borderRadius = "5px";
        this.Select.style.height = "20px";
        if (ks.kNotNullOrUndefined(ID)) {
            this.Select.id = ks.nz(ID);
        }
    }
    public SetEditable = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.Editable = true;
            this.DataList = document.createElement("datalist");
            this.Select.appendChild(this.DataList);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.SetEditable");
        }
    };
    public SetMulti = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.Select) {
                this.Select.multiple = true;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.SetMulti");
        }
    };
    public ClearChoices = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.Choices = [];
            this.Select.innerHTML = "";
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.ClearChoices");
        }
    };
    public GetSelValue = (): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (this.Select) {
                const SelectedOptions = this.Select.selectedOptions;
                if (SelectedOptions) {
                    const SelOption1:HTMLOptionElement|null = SelectedOptions.item(0);
                    if (SelOption1) {
                        return ks.nz(SelOption1.textContent);
                    }

                }
            }
            return "";
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.GetSelValue");
            return "";
        }
    };
    public GetSelIndex = (): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            if (this.Select) {
                const SelectedOptions = this.Select.selectedOptions;
                if (SelectedOptions) {
                    const SelOption1:HTMLOptionElement|null = SelectedOptions.item(0);
                    if (SelOption1) {
                        return ks.n0(SelOption1.index);
                    }

                }
            }
            return 0;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.GetSelIndex");
            return 0;
        }
    };
    public AddChoices = (NewChoices: string[],AlreadySorted?:boolean): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let CurrChoice = "";
            if(AlreadySorted !== true){
                NewChoices = NewChoices.sort();
            }
            for (CurrChoice of NewChoices) {

                this.AddChoice(CurrChoice);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.AddChoices");
        }
    };
    // public AddChoiceWithIcon = (ChoiceTitle: string,IconBase64:string): void => {
    //     const NewElement: HTMLOptionElement = this.AddChoice(ChoiceTitle);
    //     if (ks.kErrorMode === true) {return;}
    //     try {
    //         const ChoiceStyle:CSSStyleDeclaration = NewElement.style;
    //         ChoiceStyle.background = "url('" + IconBase64 +"')";
    //     } catch (e) {
    //         ks.kGlobalErrorHandler(e, "kSelect.AddChoiceWithIcon");
    //     }
    // };
    public AddChoice = (ChoiceTitle: string): HTMLOptionElement => {
        const NewElement: HTMLOptionElement = document.createElement("option");
        if (ks.kErrorMode === true) {
            return NewElement;
        }
        try {

            NewElement.textContent = ChoiceTitle;
            if (null !== this.Select) {
                if (this.Editable === true) {
                    if (this.DataList) {
                        this.DataList.appendChild(NewElement);
                    }
                } else {
                    this.Select.add(NewElement);
                }
            }
            this.Choices.push(ChoiceTitle);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.AddChoice");
        }
        return NewElement;
    };
    public AddChoiceElement = (Elem:HTMLElement,Title:string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const NewOption: HTMLOptionElement = document.createElement("option");
            NewOption.appendChild(Elem);
            NewOption.title = Title;
            if (null !== this.Select) {
                if (this.Editable === true) {
                    if (this.DataList) {
                        this.DataList.appendChild(NewOption);
                    }
                } else {
                    this.Select.add(NewOption);
                }
            }
            this.Choices.push(Title);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.AddChoiceElement");
        }
    };
    public GetOption = (Title:string): HTMLOptionElement |null => {
        if (ks.kErrorMode === true) {
            return null;
        }
        try {
            
            let CurrOption: HTMLOptionElement;
            for (CurrOption of Array.from(this.Select.options)) {
                if (CurrOption.title === Title) {
                    return CurrOption;
                }
            }
            return null;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.GetOption");
            return null;
        }
    };
    private _SelectChange = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.Select !== null) {
                if (this.Select.value === LNG.NEW) {
                    ks.DoCallBack(this.NewCB, this.Select.value, false);
                } else {
                    ks.DoCallBack(this.ChangeCB, this.Select.value, false);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect._SelectChange");
        }
    };
    public SetSelectedItemByIndex = (Index:number): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const ToBeSelectedOption: HTMLOptionElement | null = <HTMLOptionElement>this.Select.item(Index);
            if(ToBeSelectedOption){
                ToBeSelectedOption.selected = true;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.SetSelectedItemByIndex");
        }
    };
    public SetSelectedItem = (SelectedTitle: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let NewElement: HTMLOptionElement | null = null;
            let i = 0;
            if (null !== this.Select) {
                for (i = 0; i < this.Select.childElementCount; i++) {
                    NewElement = <HTMLOptionElement>this.Select.item(i);
                    if (NewElement.textContent === SelectedTitle) {
                        NewElement.selected = true;
                        break;
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.SetSelectedItem");
        }
    };
    public AddNewOption = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this.AddChoice(LNG.ADD);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kSelect.AddNewOption");
        }
    };
}
export class khtmlButton {
    public Button: HTMLButtonElement = document.createElement("button");
    public Text = "";
    public ClickDelays:boolean = true;
    public ClickCB: any = null;
    public constructor(ID?: string) {
        this.Button = document.createElement("button");
        this.Button.type = "button";
 
        const kBtnStyleClass:kStyleClass = kStyles.AddStyle("kHTMLButton");
 
        if(kBtnStyleClass.Saved === false){
            const ButtonStyle:CSSStyleDeclaration = kBtnStyleClass.Style;
            ButtonStyle.cursor = "pointer";
            ButtonStyle.color = "black";
            ButtonStyle.transitionProperty = "background-color, box-shadow, filter";
            ButtonStyle.transitionDuration = "0.15s";
            ButtonStyle.borderRadius ="5px";
            ButtonStyle.borderWidth = "thin";
        }
        kBtnStyleClass.Apply(this.Button);
        if (ks.kNotNullOrUndefined(ID)) {
            this.Button.id = ks.nz(ID);
        }
        this.Button.addEventListener("click", this._ButtonClicked);
        this.Button.addEventListener("mouseover", this._HoverIn);
        this.Button.addEventListener("mouseout", this._HoverOut);
    }
    public DisableButton = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Button) {
                this.Button.disabled = true;
                this.Button.style.backgroundColor = "white";
                this.Button.style.color = "lightgrey";
                this.Button.style.cursor = "unset";
                
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlButton.DisableButton");
        }
    };
    public EnableButton = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Button) {
                this.Button.disabled = false;
                this.Button.style.backgroundColor = "unset";
                this.Button.style.color = "black";
                this.Button.style.cursor = "pointer";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlButton.EnableButton");
        }
    };
    public SetText = (ButtonText: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Button) {
                this.Button.textContent = ButtonText;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlButton.SetText");
        }
    };
    private _ButtonClicked = (event:MouseEvent): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog === false) {
            return;
        }
        try {
            event.preventDefault();
            event.stopPropagation();
            if (null !== this.ClickCB && null !== this.Button) {
                this.Button.disabled = true;
                // this.Button.style.transitionDuration = "0s";
                // this.Button.style.backgroundColor = "lightgreen";
                // this.Button.style.transitionDuration = "0.25s";
                // this.Button.style.backgroundColor = "rgb(240, 240, 240)";
                ks.DoCallBack(this.ClickCB, undefined, false);
                if(this.ClickDelays){
                    window.setTimeout(this._Enable1sAfterClick, 1000);
                }else{
                    window.setTimeout(this._Enable1sAfterClick, 10);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlButton._ButtonClicked");
        }
    };
    private _Enable1sAfterClick = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this.Button) {
                this.Button.disabled = false;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlButton._Enable1sAfterClick");
        }
    };
    private _HoverIn = (): void => {
        try {
            if (this.Button && !this.Button.disabled) {
                this.Button.style.filter = "brightness(0.92)";
                this.Button.style.boxShadow = "0 2px 4px rgba(0,0,0,0.12)";
            }
        } catch (_e) { /* hover is non-critical */ }
    };
    private _HoverOut = (): void => {
        try {
            if (this.Button) {
                this.Button.style.filter = "";
                this.Button.style.boxShadow = "";
            }
        } catch (_e) { /* hover is non-critical */ }
    };
    public SetCallBack = (Callback: any): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Button) {
                this.ClickCB = Callback;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlButton.SetCallBack");
        }
    };
    public SetIcon = (FluentIcon:kIcon): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            FluentIcon.ToButtonIcon(this);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlButton.SetIcon");
        }
    };
    public SetWidth = (NewWidth:number): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Button) {
                const Widthpx:string = NewWidth +"px";
                const Style:CSSStyleDeclaration = this.Button.style;
                Style.width = Widthpx;
                Style.minWidth = Widthpx;
                Style.maxWidth = Widthpx;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlButton.SetWidth");
        }
    };
}

export class khtmlUploadButton {
    public UploadWrapper: HTMLDivElement = document.createElement("div");
    public Button: HTMLButtonElement = document.createElement("button");
    public Input: HTMLInputElement = document.createElement("input");
    public Text = "";
    public ClickCB: any = null;
    public constructor(ID?: string,PreventMultiple?:boolean) {
        this.UploadWrapper = new kDiv().Div;
        this.UploadWrapper.style.position = "relative";
        this.UploadWrapper.style.overflow = "hidden";
        this.UploadWrapper.style.display = "inline-block";

        this.Button = document.createElement("button");
        this.Button.type = "button";
        this.Button.style.borderRadius = "5px";
        this.UploadWrapper.appendChild(this.Button);

        this.Input = document.createElement("input");
        this.Input.type = "file";
        if (PreventMultiple !== true) {
            this.Input.multiple = true;
        }
        this.Input.style.fontSize = "100px";
        this.Input.style.position = "absolute";
        this.Input.style.left = "0";
        this.Input.style.top = "0";
        this.Input.style.opacity = "0";
            this.UploadWrapper.appendChild(this.Input);
        if (ks.kNotNullOrUndefined(ID)) {
            this.Input.id = ks.nz(ID);
        }
    }

    public SetText = (ButtonText: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Button) {
                this.Button.textContent = ButtonText;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlUploadButton.SetText");
        }
    };
    public SetCallBack = (Callback: any): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (null !== this.Input) {
                this.Input.addEventListener("change", Callback);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "khtmlUploadButton.SetCallBack");
        }
    };
}

export class kPosition {
    public Top = 0;
    public Left = 0;

    public FromElement(Element: HTMLElement): void {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const Rect: DOMRect = (Element.getBoundingClientRect() as DOMRect);
            // Make sure element is not hidden (display: none) or disconnected
            if (Rect.width || Rect.height) {
                const doc = Element.ownerDocument;
                if (doc) {
                    const docElem = doc.documentElement;
                    (this.Top = Rect.top + window.scrollY - docElem.clientTop),(this.Left = Rect.left + window.scrollX - docElem.clientLeft);
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kPosition.FromElement");
        }
    }
}

export class kRadioOption {

    public constructor(ID:string,GroupName:string) {
        this.Radio.type = "radio";
        this.Radio.id = ID;

        this.Radio.name = GroupName;
        this.Label.textContent = ID;
        this.Label.setAttribute("for",ID);
        this.ID = ID;
    }

    public Radio: HTMLInputElement = document.createElement("input");
    public Label: HTMLLabelElement = document.createElement("label");
    public ID: string = "";
    public Cell:HTMLTableCellElement =document.createElement("td");
}
export class kRadioGroup {
    public Options: kRadioOption[] = [];
    public Name = "";
    public Div: HTMLDivElement = document.createElement("div");
    public Table:kHTMLTable = new kHTMLTable();
    public OptionsRow:kHTMLRow = new kHTMLRow();
    public OnChangeCB:any = null;
    public constructor(Name: string) {
        this.Name = Name;
        this.Table.Table.style.width = "100%";
        this.Div.appendChild(this.Table.Table);
        this.OptionsRow = this.Table.AddEmptyRow();
    }
    private _ChoiceChange = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if(this.OnChangeCB){
                ks.DoCallBack(this.OnChangeCB(this.GetSelectedChoice()));
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kRadioGroup._ChoiceChange");
        }
    };
    public AddChoice = (NewChoiceTitle:string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const NewChoice: kRadioOption = new kRadioOption(NewChoiceTitle, this.Name);
            NewChoice.Radio.addEventListener("change",this._ChoiceChange);
            this.Options.push(NewChoice);
            if (this.Options.length > 1) {
                NewChoice.Radio.style.marginLeft = "20px";
            }
            NewChoice.Cell = this.OptionsRow.AddCell();

            NewChoice.Cell.appendChild(NewChoice.Radio);
            NewChoice.Cell.appendChild(NewChoice.Label);
            const ColWidth:number = 100/this.Options.length;
            for (let index = 0; index < this.Options.length;index ++){
                const CellStyle:CSSStyleDeclaration = this.Options[index].Cell.style;
                CellStyle.width = ColWidth.toString() + "%"
                CellStyle.maxWidth = ColWidth.toString() + "%"
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kRadioGroup.AddChoice");
        }
    };
    public GetSelectedChoice = (): string => {
        if (ks.kErrorMode === true) {return "";}
        try {
            let CurrOption: kRadioOption | null = null;
            for (CurrOption of this.Options) {
                if (CurrOption.Radio.checked) {
                    return CurrOption.Radio.id;
                }
            }
            return "";
        } catch (e) {ks.kGlobalErrorHandler(e, "kRadioGroup.GetSelectedChoice");return "";}
    };
    public SetSelectedChoice = (Choice:string): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            let CurrOption: kRadioOption | null = null;
            for (CurrOption of this.Options) {
                if (CurrOption.ID == Choice) {
                    CurrOption.Radio.checked = true;
                } else {
                    CurrOption.Radio.checked = false;
                }
            }
            return;
        } catch (e) { ks.kGlobalErrorHandler(e, "kRadioGroup.SetSelectedChoice"); return; }
    };
    public SetVertical = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const RadioTable:kHTMLTable = new kHTMLTable();
            let CurrOption:kRadioOption;
            for(CurrOption of this.Options){
                const CurrRow:kHTMLRow = RadioTable.AddEmptyRow();
                CurrOption.Radio.style.marginLeft = "unset";
                CurrRow.AddCellWithElement(CurrOption.Radio);
                CurrRow.AddCellWithElement(CurrOption.Label);
            }
            this.Div.appendChild(RadioTable.Table);
        } catch (e) { ks.kGlobalErrorHandler(e, "kRadioGroup.SetVertical"); return; }
    };
}

//export class kMouseEvents {

//    public static HighLight = (Event:MouseEvent): void => {
//        if (ks.kErrorMode === true) {return;}
//        try {

//        } catch (e) { ks.kGlobalErrorHandler(e, "kMouseEvents.HighLight");}
//    };
//}